import { render, staticRenderFns } from "./dev_methodologies.vue?vue&type=template&id=5859e9cf&scoped=true&"
import script from "./dev_methodologies.vue?vue&type=script&lang=js&"
export * from "./dev_methodologies.vue?vue&type=script&lang=js&"
import style0 from "./dev_methodologies.vue?vue&type=style&index=0&id=5859e9cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859e9cf",
  null
  
)

export default component.exports